import {Injectable} from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
    HttpResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {FrontendErrorHandlingService} from "../services/frontend-error-handling.service";
import {UsageTrackerService} from "../services/usage-tracker.service";
import {UsageFormFlowTrackerService} from "../services/usage-form-flow-tracker.service";

@Injectable()
export class FrontendErrorInterceptor implements HttpInterceptor {
    constructor(private errorService: FrontendErrorHandlingService, private usageTracker: UsageTrackerService,
                private formFlowTracker: UsageFormFlowTrackerService) {
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            // form & flow tracking: a successful write closes the form being edited as saved (never throws)
            tap(event => {
                if (event instanceof HttpResponse) {
                    try {
                        this.formFlowTracker.recordApiWrite(request.method, request.url);
                    } catch {
                        // usage stats only
                    }
                }
            }),
            catchError((error: HttpErrorResponse) => {
                // form & flow tracking: a refused save (400/409/422) is remembered on the open form (never throws)
                try {
                    this.formFlowTracker.recordApiWriteRejected(request.method, request.url, error?.status);
                } catch {
                    // usage stats only
                }
                this.usageTracker.recordApiError(error.status, request.method, request.url);  // never throws
                this.errorService.handleError(error);
                return throwError(error);
            })
        );
    }
}
